import { ConsoleSqlOutlined, DeleteOutlined, HomeOutlined, LinkedinOutlined, MailOutlined, PhoneOutlined, ProfileOutlined } from "@ant-design/icons";
import UploadAvatar from "@components/UploadFile/UploadFile";
import { TProfileEdit } from "@utils/Interfaces";
import { Avatar, Button, Input } from "antd";
import { useState } from "react";

const PersonalEdit: React.FC<TProfileEdit> = ({
  data,
  setAvatarFile,
  handleChangeValue,
}) => {
  const [previewImage, setPreviewImage] = useState<string | null>(null);

  const handlePreview = async (file: Blob | File) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setPreviewImage(reader.result as string);
    };
  };

  const handleSetPreviewImage = (file: Blob | File) => {
    handlePreview(file);
  };

  const handleRemovePreview = () => {
    setPreviewImage(null);
    setAvatarFile?.(null);
  };

  return (
    <div className="PersonalEdit">
      <div className="row gy-3 gx-3">
        <div className="col-12">
          <div className="d-flex align-items-center gap-4">
            <div className="flex-shrink-0">
              {!previewImage ? (
                <Avatar size={150} src={data.avatar} />
              ) : (
                <div className="avatar-preview">
                  <Avatar size={150} src={previewImage} />
                  <div className="action-wrap">
                    <Button
                      danger
                      style={{ backgroundColor: "transparent" }}
                      onClick={handleRemovePreview}
                    >
                      <DeleteOutlined style={{ fontSize: 15 }} />
                    </Button>
                  </div>
                </div>
              )}
              <div className="text-center mt-2">
                <UploadAvatar
                  setPreviewImage={handleSetPreviewImage}
                  setAvatarFile={setAvatarFile}
                />
              </div>
            </div>
            <div className="flex-grow-1">
              <div className="form-group mb-1">
                <div className="title">Account ID *</div>
                <Input value={data.id} disabled size="large" />
              </div>
              <div className="form-group mb-1">
                <div className="title">First name *</div>
                <Input
                  value={data.first_name}
                  onChange={(e): void =>
                    handleChangeValue(e.target.value, "first_name")
                  }
                  maxLength={20}
                  size="large"
                />
              </div>
              <div className="form-group">
                <div className="title">Last name *</div>
                <Input
                  value={data.last_name}
                  onChange={(e): void =>
                    handleChangeValue(e.target.value, "last_name")
                  }
                  maxLength={20}
                  size="large"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <div className="title">Display name *</div>
            <Input
              value={data.display_name}
              onChange={(e): void =>
                handleChangeValue(e.target.value, "display_name")
              }
              maxLength={25}
              size="large"
              prefix={<ProfileOutlined />}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <div className="title">Email *</div>
            <Input
              value={data.email}
              disabled
              size="large"
              prefix={<MailOutlined />}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <div className="title">Phone *</div>
            <Input
              value={data.phone || ""}
              onChange={(e): void => handleChangeValue(e.target.value, "phone")}
              size="large"
              prefix={<PhoneOutlined />}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <div className="title">Country *</div>
            <Input
              value={data.location || ""}
              onChange={(e): void =>
                handleChangeValue(e.target.value, "location")
              }
              size="large"
              prefix={<HomeOutlined />}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <div className="title">Address *</div>
            <Input
              value={data.address || ""}
              size="large"
              prefix={<HomeOutlined />}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <div className="title">Job Title *</div>
            <Input size="large" prefix={<ConsoleSqlOutlined />} />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <div className="title">LinkedIn *</div>
            <Input size="large" prefix={<LinkedinOutlined />} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalEdit;